module.exports = __webpack_public_path__ + "static/media/Ethereum.db6645a5.svg";